/**
 * Lazily loads and caches the constants, schemas and helpers shared by
 * ApiController and TypedApiController.
 *
 * The imports stay dynamic so none of these modules end up in the entry chunk.
 */
let cache: any = null

export const getApiModules = async () => {
  if (cache) return cache

  const [
    { API_URL, REQUEST_URL },
    { CATEGORY_PAGE_API_URL },
    { CART_PAGE_URL },
    { PDP_REQUEST_URL },
    { CMS_PAGE_URL },
    { COLLECTION_PAGE_API_URL },
    { default: ChunkSchema },
    { default: CustomerReviewSchema },
    { default: AddressSchema },
    { default: ManufacturerSchema },
    { default: CategorySchema },
    { default: ProductSchema },
    { default: MetaProductSchema },
    { default: CmsPageSchema },
    { default: RequestHelper, getRequestPathname },
    { default: UtilityHelper },
    { default: SchemaValidator },
    { default: TrackingHelper }
  ] = await Promise.all([
    import('@/constants/GlobalConstants'),
    import('@/constants/CategoryPageConstants'),
    import('@/constants/CartPageConstants'),
    import('@/constants/PdpConstants'),
    import('@/constants/CmsPageConstants'),
    import('@/constants/CollectionPageConstants'),
    import('@/modules/schemas/customer/ChunkSchema'),
    import('@/modules/schemas/CustomerReviewSchema'),
    import('@/modules/schemas/customer/AddressSchema'),
    import('@/modules/schemas/ManufacturerSchema'),
    import('@/modules/schemas/CategorySchema'),
    import('@/modules/schemas/product/ProductSchema'),
    import('@/modules/schemas/product/MetaProductSchema'),
    import('@/modules/schemas/CmsPageSchema'),
    import('@/services/helpers/RequestHelper'),
    import('@/services/helpers/UtilityHelper'),
    import('@/modules/schemas/SchemaValidator'),
    import('@/services/helpers/TrackingHelper')
  ])

  cache = {
    API_URL,
    REQUEST_URL,
    CATEGORY_PAGE_API_URL,
    PDP_REQUEST_URL,
    CMS_PAGE_URL,
    COLLECTION_PAGE_API_URL,
    CART_PAGE_URL,
    ChunkSchema,
    CustomerReviewSchema,
    AddressSchema,
    ManufacturerSchema,
    CategorySchema,
    ProductSchema,
    MetaProductSchema,
    CmsPageSchema,
    RequestHelper,
    getRequestPathname,
    UtilityHelper,
    SchemaValidator,
    TrackingHelper
  }
  return cache
}
